import "./PrivacyPolicy2.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyHero from "./sections/PrivacyPolicyHero";
import IntroductionWhoWeAre from "./sections/IntroductionWhoWeAre";
import InformationWeCollect from "./sections/InformationWeCollect";
import DataUsagePolicy from "./sections/DataUsagePolicy";
import DataProtectionDetails from "./sections/DataProtectionDetails";
import UserRightsAndPolicies from "./sections/UserRightsAndPolicies";
import PolicyUpdatesAndContact from "./sections/PolicyUpdatesAndContact";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicy2Page() {
  return <div>
      <Header />
      <PrivacyPolicyHero />
      <IntroductionWhoWeAre />
      <InformationWeCollect />
      <DataUsagePolicy />
      <DataProtectionDetails />
      <UserRightsAndPolicies />
      <PolicyUpdatesAndContact />
      <Footer />
    </div>;
}